import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setOpenNameScriptInstructionModal,
  setInlineNameScriptInstruction,
  setNameScriptInstructionId,
} from '../../../../store/modules/script-editor/actions';
import { selectNameScriptInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerNameScriptActions } from './utils';
import NameScriptInstructionModal from './NameScriptInstructionModal';

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const NameScriptInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectNameScriptInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_NAME_SCRIPT_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenNameScriptInstructionModal(true));
          dispatch(setNameScriptInstructionId(data.instructionId));
          dispatch(setInlineNameScriptInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_NAME_SCRIPT_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerNameScriptActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerNameScriptActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <NameScriptInstructionModal instanceEditor={instanceEditor} />
  );
};

export default NameScriptInstructionComponent;
